var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgJumpsuit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.87 16.958l-.007-.043c-.731-3.659-.54-4.978-.298-6.648a24.69 24.69 0 00.31-3.923v-4.75a.593.593 0 10-1.187 0v1.78h-.594c-1.78 0-2.969 1.188-3.562 2.842-.593-1.654-1.781-2.842-3.562-2.842h-.594v-1.78a.593.593 0 10-1.188 0V7.53c-.032 1.137.08 2.274.335 3.381.225 1.007.388 1.733-.33 6.047l-1.188 9.5a.592.592 0 00.588.666h3.563c.278 0 .52-.193.58-.464l1.796-9.267 1.794 9.267c.06.271.302.464.58.464h3.563a.594.594 0 00.589-.667l-1.188-9.5z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}

export default SvgJumpsuit;